import { SECTION_CHILD_PATHS } from '@/features/navigation/sidebar/sidebar.config';
import { isFrontendPreviewRoute } from './frontendPreviewRoutes';
import { ROUTE_GATES, UNRESTRICTED_NAVIGATION_PATHS } from './gates';

type Perms = { canAny: (keys: readonly string[]) => boolean };

const GATED_PATHS_BY_SPECIFICITY = Object.keys(ROUTE_GATES).sort((a, b) => b.length - a.length);

const normalizePath = (path: string) => path.replace(/\/$/, '');

const matchesPathOrDescendant = (path: string, basePath: string) =>
  path === basePath || path.startsWith(`${basePath}/`);

export function canAccessRoute(path: string | undefined, perms: Perms) {
  if (!path) return false;
  const clean = normalizePath(path);
  if (isFrontendPreviewRoute(clean)) return true;
  const required = ROUTE_GATES[clean];
  if (!required) return UNRESTRICTED_NAVIGATION_PATHS.has(clean);
  return perms.canAny(required);
}

export function canAccessNavigationPath(path: string | undefined, perms: Perms) {
  if (!path) return false;

  const clean = normalizePath(path);

  if (clean === '/forbidden' || clean in SECTION_CHILD_PATHS) return true;
  if (isFrontendPreviewRoute(clean)) return true;

  const gatedPath = GATED_PATHS_BY_SPECIFICITY.find((route) => matchesPathOrDescendant(clean, route));

  if (gatedPath) return perms.canAny(ROUTE_GATES[gatedPath]);

  for (const route of UNRESTRICTED_NAVIGATION_PATHS) {
    if (matchesPathOrDescendant(clean, route)) return true;
  }

  return false;
}
